export default __webpack_public_path__ + "static/media/chevron-left.6f544f3c.svg";